// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"280":"a42be768","453":"b49d1534","779":"3c89d644"}[chunkId] + ".chunk.js");